import noImage from '../assets/images/no-image.jpg'

export const getImage = (image, isNullable) => {
  if (image != null) return image.url
  return isNullable ? null : noImage
}
